import tableAppCategories from './tableRelatedAppCategories';

export default {
  title: 'Categories',
  attributeName: 'appCategoryContent',
  getURL: 'appCategoryContent/appId/areaId',
  noArea:true,
  noTitle:true,
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId', 'areaId'],
  tableConfig: tableAppCategories,
  autoUpdate: true,

};
